import { Provider } from '@angular/core';
import { SystemDataHttpService } from './abstract';
import { SystemDataHttpServiceImpl } from './system-data-http.service';

export const SystemDataHttpProvider: Provider = {
	provide: SystemDataHttpService,
	useClass: SystemDataHttpServiceImpl,
};
